import { render, staticRenderFns } from "./DefaultNav.vue?vue&type=template&id=03bf64c4&scoped=true"
import script from "./DefaultNav.vue?vue&type=script&lang=js"
export * from "./DefaultNav.vue?vue&type=script&lang=js"
import style0 from "./DefaultNav.vue?vue&type=style&index=0&id=03bf64c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf64c4",
  null
  
)

export default component.exports